import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';

//utils
import queries from '../../../utils/queries'

import HomeRtes1 from './homertes1';
import HomeRtes2 from './homertes2';

import RtesCli1 from './rtescli1';
import RtesCli2 from './rtescli2';
import RtesMovDi1 from './rtesmovdi1';
import RtesMovDi2 from './rtesmovdi2';
import RtesMovDi2_BV from './rtesmovdi2_bv';
import RtesOS1 from './rtesos1';
import RtesOS2 from './rtesos2';
import RtesFact1 from './rtesfact1';
import RtesFact2 from './rtesfact2';
import RtesGesTro1 from './rtesgestro1';
import RtesGesTro2 from './rtesgestro2';
import RtesNotAju1 from './rtesnotaju1';
import RtesNotAju2 from './rtesnotaju2';

class HomeRtes extends React.Component{
  state={
    showRtes: true,
    showRtesCli: false,
    showRtesMovDi: false,
    showRtesOS: false,
    showRtesFact: false,
    showRtesGesTro: false,
    showRtesNotAju: false,
    argsAdd: {},
    permiteOpcion1: true,
    permiteOpcion2: false,
    permiteOpcion3: false,
    permiteOpcion4: false
  }

  estadosFalse = () => {
    this.setState({argsAdd: {}})
    Object.values(this.state).forEach((estado, i) => {
      if(estado===true&&
        Object.getOwnPropertyNames(this.state)[i]!=="permiteOpcion1"&&
        Object.getOwnPropertyNames(this.state)[i]!=="permiteOpcion2"&&
        Object.getOwnPropertyNames(this.state)[i]!=="permiteOpcion3"&&
        Object.getOwnPropertyNames(this.state)[i]!=="permiteOpcion4"){
          this.setState({ [Object.getOwnPropertyNames(this.state)[i]]: false })
      }
    })
  }

  showRtes = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showRtes: true})
  }

  selCiudad = () => {
    if(this.props.allDirmayor.allDirmayor){
      const argsAdd = this.state.argsAdd

      let listaDir = this.props.allDirmayor.allDirmayor
      if(this.props.codigoDptoUA!=="Todos..."&&this.props.codigoCiudadUA==="Todas..."){
        listaDir = listaDir.filter(elemento => elemento.codigoDpto===this.props.codigoDptoUA)
        argsAdd['codigoDpto'] = listaDir[0].codigoDpto
        argsAdd['descrDpto'] = listaDir[0].descrDpto
        argsAdd['_id'] = listaDir[0]._id
        this.setState({argsAdd});
      }
      if(this.props.codigoCiudadUA!=="Todas..."){
        const argsAdd = this.state.argsAdd
        let dptoOK = false
        listaDir.forEach((elemento, _id) => {
          if(!dptoOK){
            elemento.ciudades.forEach((elemento1, _id) => {
              if(elemento1.codigoCiudad===this.props.codigoCiudadUA){
                dptoOK = true
                argsAdd['codigoDpto'] = elemento.codigoDpto
                argsAdd['descrDpto'] = elemento.descrDpto
                argsAdd['_id'] = elemento._id
                argsAdd['nombreCiudad'] = elemento1.nombreCiudad
                argsAdd['codigoCiudad'] = elemento1.codigoCiudad
                this.setState({argsAdd});
                // console.log(argsAdd)
              }
            })
          }
        })
        // console.log(argsAdd)
      }
      // console.log(lista1)
    }
  }

  showRtesCli = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showRtesCli: true})
    
    this.selCiudad()
  }

  showRtesMovDi = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showRtesMovDi: true})
    
    this.selCiudad()
  }

  showRtesOS = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showRtesOS: true})
    
    this.selCiudad()
  }

  showRtesFact = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showRtesFact: true})
    
    this.selCiudad()
  }

  showRtesGesTro = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showRtesGesTro: true})
    
    this.selCiudad()
  }

  showRtesNotAju = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showRtesNotAju: true})
    
    this.selCiudad()
  }

  handleCiudadDpto = () => {
    this.setState({argsAdd: {}})
    let miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd
    argsAdd['codigoDpto'] = miLista.options[miLista.selectedIndex].attributes[0].value
    argsAdd['descrDpto'] = miLista.options[miLista.selectedIndex].text
    argsAdd['_id'] = miLista.options[miLista.selectedIndex].value
    this.setState({argsAdd});
  }

  handleZonaCiudad = () => {
    var miLista = document.getElementById("miLista1");
    const argsAdd = this.state.argsAdd
    argsAdd['nombreCiudad'] = miLista.options[miLista.selectedIndex].text
    argsAdd['codigoCiudad'] = miLista.options[miLista.selectedIndex].value
    this.setState({argsAdd});
  }

  handleBarrioZona = () => {
    var miLista = document.getElementById("miLista2");
    const argsAdd = this.state.argsAdd
    argsAdd['nombreZona'] = miLista.options[miLista.selectedIndex].text
    argsAdd['codigoZona'] = miLista.options[miLista.selectedIndex].value
    this.setState({argsAdd});
    // console.log(argsAdd)
  }

  handleBarrioSel = () => {
    var miLista = document.getElementById("miLista3");
    const argsAdd = this.state.argsAdd
    argsAdd['nombreBarrio'] = miLista.options[miLista.selectedIndex].text
    argsAdd['codigoBarrio'] = miLista.options[miLista.selectedIndex].value
    argsAdd['codigoTipoDocT'] = miLista.options[miLista.selectedIndex].attributes[0].value
    argsAdd['numeroDocumT'] = miLista.options[miLista.selectedIndex].attributes[1].value
    argsAdd['descrRecursoT'] = miLista.options[miLista.selectedIndex].attributes[2].value
    argsAdd['codigoTipoDocR'] = miLista.options[miLista.selectedIndex].attributes[3].value
    argsAdd['numeroDocumR'] = miLista.options[miLista.selectedIndex].attributes[4].value
    argsAdd['descrRecursoR'] = miLista.options[miLista.selectedIndex].attributes[5].value

//     argsAdd['nombreBarrio'] = miLista.options[miLista.selectedIndex].text
//     argsAdd['codigoBarrio'] = miLista.options[miLista.selectedIndex].value
// //si miLista.options[miLista.selectedIndex].attributes[0] no existe pone codigoBarrio que es el value
// //=> se valida por miLista.options[miLista.selectedIndex].attributes[1]
//     argsAdd['codigoTipoDocT'] = miLista.options[miLista.selectedIndex].attributes[1]?miLista.options[miLista.selectedIndex].attributes[0].value:null
//     argsAdd['numeroDocumT'] = miLista.options[miLista.selectedIndex].attributes[1]?miLista.options[miLista.selectedIndex].attributes[1].value:null
//     argsAdd['descrRecursoT'] = miLista.options[miLista.selectedIndex].attributes[2]?miLista.options[miLista.selectedIndex].attributes[2].value:null
//     argsAdd['codigoTipoDocR'] = miLista.options[miLista.selectedIndex].attributes[3]?miLista.options[miLista.selectedIndex].attributes[3].value:null
//     argsAdd['numeroDocumR'] = miLista.options[miLista.selectedIndex].attributes[4]?miLista.options[miLista.selectedIndex].attributes[4].value:null
//     argsAdd['descrRecursoR'] = miLista.options[miLista.selectedIndex].attributes[5]?miLista.options[miLista.selectedIndex].attributes[5].value:null
// console.log(argsAdd)
    this.setState({argsAdd});
  }

  handleClaseSub = () => {
    var miLista4 = document.getElementById("miLista4");
    const argsAdd = this.state.argsAdd
    argsAdd['descrClaseServ'] = miLista4.options[miLista4.selectedIndex].text
    argsAdd['_idClaseserv'] = miLista4.options[miLista4.selectedIndex].value
    argsAdd['codigoClaseServ'] = miLista4.options[miLista4.selectedIndex].attributes[0].value
    this.setState({argsAdd});
  }

  handleClickOpc1 = (ev) => {
    ev.preventDefault()
    this.setState({permiteOpcion1: true})
    this.setState({permiteOpcion2: false})
    this.setState({permiteOpcion3: false})
    this.setState({permiteOpcion4: false})
  }

  handleClickOpc2 = (ev) => {
    ev.preventDefault()
    this.setState({permiteOpcion1: false})
    this.setState({permiteOpcion2: true})
    this.setState({permiteOpcion3: false})
    this.setState({permiteOpcion4: false})
  }

  handleClickOpc3 = (ev) => {
    ev.preventDefault()
    this.setState({permiteOpcion1: false})
    this.setState({permiteOpcion2: false})
    this.setState({permiteOpcion3: true})
    this.setState({permiteOpcion4: false})
  }

  handleClickOpc4 = (ev) => {
    ev.preventDefault()
    this.setState({permiteOpcion1: false})
    this.setState({permiteOpcion2: false})
    this.setState({permiteOpcion3: false})
    this.setState({permiteOpcion4: true})
  }

  render(){
    const {showRtes, showRtesMovDi, showRtesCli, showRtesOS, showRtesFact, showRtesGesTro, showRtesNotAju,
            argsAdd, permiteOpcion1, permiteOpcion2, permiteOpcion3, permiteOpcion4} = this.state;

      const a150510 = this.props.autorizacUA.findIndex( autorizac => autorizac === "150510" );
      
      let lista = []
      let lista1 = []
      let lista2 = []
      let lista3 = []
      let lista4 = []
      // let lista7 = []
      // console.log("aa")
// console.log(this.props.allDirmayor.allDirmayor)
      if (this.state.showRtesCli||this.state.showRtesMovDi||this.state.showRtesOS||this.state.showRtesFact||
          this.state.showRtesGesTro||this.state.showRtesNotAju) {
        if(this.props.allDirmayor.allDirmayor){
          let listaDir = this.props.allDirmayor.allDirmayor
          if(this.props.codigoCiudadUA!=="Todas..."){
            let listaD = []
            listaDir.forEach((elemento, _id) => {
              if(listaD.length===0){
                elemento.ciudades.forEach((elemento1, _id) => {
                  if(elemento1.codigoCiudad===this.props.codigoCiudadUA){
                    listaD.push(elemento)
                  }
                })
              }
            })
            if (this.state.showRtesFact||this.state.showRtesGesTro){
              lista3 = listaD
            }else{
              lista1 = listaD
            }
          }else{
            if (this.state.showRtesFact||this.state.showRtesGesTro){
              lista3 = listaDir
            }else{
              lista1 = listaDir
            }
          }
          // console.log(lista1)
        }
      }

      if (this.state.showRtesCli) {
        // if(this.props.allDirmayor.allDirmayor){lista1 = this.props.allDirmayor.allDirmayor}
        lista2.push({estadoCli: "NUEVO"})
        lista2.push({estadoCli: "ACTIVO"})
        lista2.push({estadoCli: "DESCONECTADO"})
        lista2.push({estadoCli: "SUSPENDIDO"})
        lista2.push({estadoCli: "RETIRADO"})
        if(this.props.allRecurso.allRecurso){
          lista = this.props.allRecurso.allRecurso
          lista = lista.filter(elemento => elemento.tiporec.areaAprovech==='RECAUDO')
        }
        if(this.props.allClasesServ.allClasesServ){lista3 = this.props.allClasesServ.allClasesServ}
      }
      if (this.state.showRtesMovDi) {
        // if(this.props.allDirmayor.allDirmayor){lista1 = this.props.allDirmayor.allDirmayor}
        if(this.props.allClasesServ.allClasesServ){lista2 = this.props.allClasesServ.allClasesServ}
        if(this.props.allRecurso.allRecurso){
          lista = this.props.allRecurso.allRecurso
          if(this.props.numeroDocumUA==="Todos..."){
            lista = lista.filter(elemento => elemento.tiporec.areaAprovech==='RECAUDO')
          }else{
            lista = lista.filter(elemento => elemento.tiporec.areaAprovech==='RECAUDO'&&
                                  elemento.numeroDocum===this.props.numeroDocumUA)
          } 
          if(this.props.codigoDptoUA!=="Todos..."){
            lista = lista.filter(elemento => elemento.codigoDpto==="Todos..." || elemento.codigoDpto===this.props.codigoDptoUA)
          }
          if(this.props.codigoCiudadUA!=="Todas..."){
            lista = lista.filter(elemento => elemento.codigoCiudad==="Todas..." || elemento.codigoCiudad===this.props.codigoCiudadUA)
          }
        }
      }
      // console.log(lista)
      if (this.state.showRtesOS) {
        // if(this.props.allDirmayor.allDirmayor){lista1 = this.props.allDirmayor.allDirmayor}
        lista2.push({estadoOS: "ABIERTA"})
        lista2.push({estadoOS: "CERRADA"})
        lista2.push({estadoOS: "CANCELADA"})
        if(this.props.allRecurso.allRecurso){
          lista = this.props.allRecurso.allRecurso
          lista = lista.filter(elemento => elemento.tiporec.areaAprovech==='TECNICA')

          lista3 = this.props.allRecurso.allRecurso
          lista3 = lista3.filter(elemento => elemento.tiporec.areaAprovech==='VENTAS')

          lista4 = this.props.allRecurso.allRecurso
          lista4 = lista4.filter(elemento => elemento.tiporec.areaAprovech==='RECAUDO')
        }
      }
      if (this.state.showRtesFact) {
        if(this.props.allRangoFact.allRangoFact){lista = this.props.allRangoFact.allRangoFact}
        if(this.props.allProcFact.allProcFact){lista1 = this.props.allProcFact.allProcFact}
        if(this.props.allClasesServ.allClasesServ){lista2 = this.props.allClasesServ.allClasesServ}
        // if(this.props.allDirmayor.allDirmayor){lista3 = this.props.allDirmayor.allDirmayor}
      }
      if (this.state.showRtesGesTro) {
        if(this.props.allRangoFact.allRangoFact){lista = this.props.allRangoFact.allRangoFact}
        if(this.props.allProcFact.allProcFact){lista1 = this.props.allProcFact.allProcFact}
        if(this.props.allClasesServ.allClasesServ){lista2 = this.props.allClasesServ.allClasesServ}
      }
      if (this.state.showRtesNotAju) {
        if(this.props.allRangoFact.allRangoFact){lista = this.props.allRangoFact.allRangoFact}
        if(this.props.allClasesServ.allClasesServ){lista2 = this.props.allClasesServ.allClasesServ}
      }
// console.log("bb")
// console.log(permiteOpcion1, permiteOpcion2, permiteOpcion3, permiteOpcion4)
      return (
      <div>
        <div className="ui two column stackable grid">
          <div className="column" style={this.props.styles.boxIzq}>
            {showRtes && <HomeRtes1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickSel1={this.showRtesCli}
                        handleClickSel2={this.showRtesMovDi} handleClickSel3={this.showRtesOS}
                        handleClickSel4={this.showRtesFact} handleClickSel5={this.showRtesGesTro}
                        handleClickSel6={this.showRtesNotAju}/>}

            {showRtesCli && <RtesCli1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showRtes}/>}

            {showRtesMovDi && <RtesMovDi1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showRtes}/>}

            {showRtesOS && <RtesOS1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showRtes}/>}

            {showRtesFact && <RtesFact1 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                            handleClickRegr={this.showRtes} handleClickSel1={this.handleClickOpc1}
                            handleClickSel2={this.handleClickOpc2}/>}

            {showRtesGesTro && <RtesGesTro1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showRtes}
                            handleClickSel1={this.handleClickOpc1} handleClickSel2={this.handleClickOpc2}/>}

            {showRtesNotAju && <RtesNotAju1 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                            handleClickRegr={this.showRtes} handleClickSel1={this.handleClickOpc1}
                            handleClickSel2={this.handleClickOpc2} handleClickSel3={this.handleClickOpc3}
                            handleClickSel4={this.handleClickOpc4}/>}

          </div>
          <div className="column" style={this.props.styles.boxDer}>
            {showRtes && <HomeRtes2 styles={this.props.styles}/>}

            {showRtesCli && <RtesCli2 autorizacUA={this.props.autorizacUA} codigoCiudadUA={this.props.codigoCiudadUA}
                              codigoDptoUA={this.props.codigoDptoUA} styles={this.props.styles} list={lista}
                              list1={lista1} list2={lista2} list3={lista3} listaCF={this.props.listaCF}
                              handleLista={this.handleCiudadDpto}
                              handleLista1={this.handleZonaCiudad} handleLista2={this.handleBarrioZona}
                              handleLista3={this.handleBarrioSel} handleLista4={this.handleClaseSub}
                              argsSelDpto={argsAdd}
                              handleClickRegr={this.showRtes} empresa={this.props.empresa}/>}

            {(showRtesMovDi&&this.props.empresa.empresaArchFE!=="codisert") && <RtesMovDi2 autorizacUA={this.props.autorizacUA}
                              codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}
                              numeroDocumUA={this.props.numeroDocumUA} styles={this.props.styles}
                              list={lista} list1={lista1} list2={lista2} listaCF={this.props.listaCF}
                              handleLista={this.handleCiudadDpto}
                              handleLista1={this.handleZonaCiudad} handleLista2={this.handleBarrioZona}
                              handleLista3={this.handleBarrioSel} handleLista4={this.handleClaseSub}
                              listaOf={this.props.listaOf} argsSelDpto={argsAdd}
                              handleClickRegr={this.showRtes} empresa={this.props.empresa}
                              a150510={a150510}/>}
            {(showRtesMovDi&&this.props.empresa.empresaArchFE==="codisert") && <RtesMovDi2_BV autorizacUA={this.props.autorizacUA}
                              codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}
                              numeroDocumUA={this.props.numeroDocumUA} styles={this.props.styles}
                              list={lista} list1={lista1} list2={lista2} listaCF={this.props.listaCF}
                              handleLista={this.handleCiudadDpto}
                              handleLista1={this.handleZonaCiudad} handleLista2={this.handleBarrioZona}
                              handleLista3={this.handleBarrioSel} handleLista4={this.handleClaseSub}
                              listaOf={this.props.listaOf} argsSelDpto={argsAdd}
                              handleClickRegr={this.showRtes} empresa={this.props.empresa}
                              a150510={a150510}/>}

            {showRtesOS && <RtesOS2 autorizacUA={this.props.autorizacUA}
                              codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}
                              styles={this.props.styles} list={lista}
                              list1={lista1} list2={lista2} list3={lista3} list4={lista4}
                              handleLista={this.handleCiudadDpto}
                              handleLista1={this.handleZonaCiudad} handleLista2={this.handleBarrioZona}
                              handleLista3={this.handleBarrioSel}
                              argsSelDpto={argsAdd}
                              handleClickRegr={this.showRtes} empresa={this.props.empresa}/>}

            {showRtesFact && <RtesFact2 autorizacUA={this.props.autorizacUA}
                              codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}
                              styles={this.props.styles}
                              list={lista} list1={lista1} list2={lista2} list3={lista3}
                              handleLista={this.handleCiudadDpto}
                              handleLista1={this.handleZonaCiudad}
                              handleLista4={this.handleClaseSub}
                              argsSelDpto={argsAdd} handleClickRegr={this.showRtes}
                              permiteOpcion1={permiteOpcion1} permiteOpcion2={permiteOpcion2}
                              empresa={this.props.empresa}/>}

            {showRtesGesTro && <RtesGesTro2 autorizacUA={this.props.autorizacUA}
                              codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}
                              styles={this.props.styles} list={lista} list1={lista1} list3={lista3}
                              list2={lista2} listaCF={this.props.listaCF} handleLista4={this.handleClaseSub}
                              empresa={this.props.empresa}
                              handleLista={this.handleCiudadDpto} handleLista1={this.handleZonaCiudad}
                              argsSelDpto={argsAdd} handleClickRegr={this.showRtes}
                              permiteOpcion1={permiteOpcion1} permiteOpcion2={permiteOpcion2}/>}

            {showRtesNotAju && <RtesNotAju2 autorizacUA={this.props.autorizacUA}
                              codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}
                              styles={this.props.styles}
                              list={lista} list1={lista1} list2={lista2} handleClickRegr={this.showRtes}
                              handleLista={this.handleCiudadDpto} handleLista1={this.handleZonaCiudad}
                              empresa={this.props.empresa} handleLista4={this.handleClaseSub}
                              argsSelDpto={argsAdd}
                              permiteOpcion1={permiteOpcion1} permiteOpcion2={permiteOpcion2}
                              permiteOpcion3={permiteOpcion3} permiteOpcion4={permiteOpcion4}/>}

          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allDirmayor, {name:'allDirmayor', options: (props) => {return {variables: {}}}}),
  graphql(queries.query.allClasesServ, {name:'allClasesServ'}),

  graphql(queries.query.allRecurso, {name:'allRecurso', options: (props) => {return {variables: {}}}}),

  graphql(queries.query.allRangoFact, {name:'allRangoFact', options: (props) => {return {variables: {}}}}),
  graphql(queries.query.allProcFact, {name:'allProcFact', options: (props) => {return {variables: {}}}}),

//   graphql(queries.query.allRtesMovDi, {name:'allRtesMovDi', options: (props) => {return {variables: {}}}}),

  )(HomeRtes)
